import { Avatar, Tooltip } from "@mui/material";
import React from "react";
import PropTypes from "prop-types";

const UserAvatar = ({
  username = "user",
  size = 60,
  variant = "circular",
  showTooltip = true,
  tooltipTitle = "",
  onClick
}) => {
  const safeUsername = username || "user";

  const avatarStyles = {
    height: size,
    width: size,
    backgroundColor: getRandomColor(safeUsername),
    cursor: onClick ? "pointer" : "default",
    transition: "transform 0.2s ease, box-shadow 0.2s ease",
    "&:hover": {
      transform: onClick ? "scale(1.1)" : "none",
      boxShadow: onClick ? "0 0 10px rgba(0,0,0,0.2)" : "none"
    }
  };

  const avatar = (
    <Avatar
      variant={variant}
      sx={avatarStyles}
      src={`https://robohash.org/${safeUsername}?set=set4`}
      alt={safeUsername}
      onClick={onClick}
    />
  );

  return showTooltip ? (
    <Tooltip title={tooltipTitle || `@${safeUsername}`} arrow>
      {avatar}
    </Tooltip>
  ) : (
    avatar
  );
};

function getRandomColor(str = "") {
  if (!str) return "hsl(0, 0%, 70%)";

  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }

  const hue = Math.abs(hash % 360);
  return `hsl(${hue}, 70%, 60%)`;
}

UserAvatar.propTypes = {
  username: PropTypes.string,
  size: PropTypes.number,
  variant: PropTypes.oneOf(["circular", "rounded", "square"]),
  showTooltip: PropTypes.bool,
  tooltipTitle: PropTypes.string,
  onClick: PropTypes.func
};

export default UserAvatar;
